export const origin = '/api';

// appgrowing(console) 后端。FP 前端有几处跨域回调它：用户组变更通知、规则字段候选、一键建 AB 测。
// 跨域由 console 的前置层统一放行（allow-origin: *），前端不需要额外处理。
export const appgrowingOrigin = 'https://console.teamremoter.com';
